import { SortableContainer, util } from 'app/core/util/util';
import { PackingMaterial } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { DetailFlowPanelStatus } from 'app/modules/florder/florder-edit-container/florder-edit.interface';
import { takeUntil } from 'rxjs/operators';
import { Destroyable } from '@dlw-int-mwi/eps-common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { LayoutBreakpoints } from '../../../core/util/layout-breakpoints';

@Component({
  selector: 'app-flow-material-lines',
  templateUrl: './flow-material-lines.component.html',
  styleUrls: ['../../florder/florder-material-lines/florder-material-lines.component.scss'],
})
export class FlowMaterialLinesComponent extends Destroyable implements SortableContainer {
  @Input() titlePart: string;
  @Input() materials: PackingMaterial[];
  @Input() definitions: Definitions;
  @Input() panelStatus: DetailFlowPanelStatus;
  @Input('sort') filter: { sortField: string, sortAscending: boolean };

  @Output() editMaterialClicked = new EventEmitter<PackingMaterial>();
  @Output() removeMaterialClicked = new EventEmitter<PackingMaterial>();
  @Output() sortChange = new EventEmitter<{ sortField: string, sortAscending: boolean }>();

  private deviceType = util.deviceType();
  public connectorHeight: number;
  public connectorWidth: number;
  isMobile = false;
  isNumeric = util.isNumeric;
  labelPosition: 'top' | 'none' = 'none';

  constructor(private breakpointObserver: BreakpointObserver, cd: ChangeDetectorRef) {
    super();
    LayoutBreakpoints.matches(breakpointObserver, LayoutBreakpoints.extraSmallScreenOrLess).pipe(
      takeUntil(this.destroyed$),
    ).subscribe(isMobile => {
      this.isMobile = isMobile;
      cd.markForCheck();
    });

    breakpointObserver.observe(LayoutBreakpoints.bootstrapSmOrLess).pipe(this.takeUntilDestroyed()).subscribe((match) => {
      if (match.matches) {
        this.labelPosition = 'top';
      } else {
        this.labelPosition = 'none';
      }
      cd.markForCheck();
    })

    switch (this.deviceType) {
      case 'mobile': {
        this.connectorHeight = 140;
        this.connectorWidth = 30;
        break;
      }
      case 'tablet': {
        this.connectorHeight = 140;
        this.connectorWidth = 30;
        break;
      }
      case 'desktop': {
        this.connectorHeight = 50;
        this.connectorWidth = 20;
        break;
      }
    }
  }

  getContent(id: string): string {
    const brick = id && this.definitions.global.brick.find(b => b.id === id);
    return brick && brick.name;
  }

  showDisputeQuantity(material: PackingMaterial): boolean {
    return util.isNumeric(material.disputeQuantity);
  }

  canRemoveMaterial(material: PackingMaterial) {
    return this.panelStatus.canRemoveExistingLines || material.isNew;
  }

  changeSort(field: string) {
    util.sortHelper(this, field, false, false);
  }

  changeSortBnd = this.changeSort.bind(this);

  editMaterial(material: PackingMaterial) {
    this.editMaterialClicked.emit(material);
  }

}
